export default __webpack_public_path__ + "static/media/02.77b49c05.jpg";